import { useEffect, useState } from "react";
import { IFormData } from "../../pages/seller-stepper/SellerStepper";
import { SubmitHandler, useForm } from "react-hook-form";
import ButtonComponent from "../elements/ButtonComponent";
import { InputMask } from "@react-input/mask";
import { Controller } from "react-hook-form";
import { motion } from "framer-motion";
import { childVariants } from "../../animation/RoutesAnimations";
import { zodResolver } from "@hookform/resolvers/zod";
import customZ from "../../utils/setZodCustomMessages";
import { BASE_URL, axiosPrivate } from "../../api/axios";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/LoadingBg.json";
import {
  notEmptyField,
  bankNumberSchema,
  notEmptyAndPersianField,
  shabaBankNumberSchema,
  optonalStringInput,
} from "../../utils/customSchemas";
import { useQuery } from "@tanstack/react-query";
import _ from "lodash";
import {
  BANKS_LIST,
  GET_FILE_UID,
  STORE_STORE_BANK_INFO_CREATE,
  STORE_STORE_BANK_INFO_GET,
  STORE_STORE_BANK_INFO_UPDATE,
} from "../../api/apiClient";

const step4Schema = customZ.object({
  bank_card_number: notEmptyField,
  account_number: bankNumberSchema,
  IBAN: shabaBankNumberSchema,
  bank_uid: optonalStringInput,
  branch_code: notEmptyAndPersianField,
});

export type BankAccountProps = {
  onBack?: any;
  setIsLoadingContents?: any;
};

function BankAccount({
  formNo,
  setFormNo,
  storeUid,
  setStoreStateConfirmInfo,
}: any) {
  const {
    register,
    setValue,
    watch,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<IFormData>({
    resolver: (data, context, options) => {
      return zodResolver(step4Schema)(data, context, options);
    },
  });

  // const [valueInput, setValueInput] = useState("");
  // const [disableContinueBtn, setDisableContinueBtn] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [getData, setGetData] = useState<any>(undefined);
  const [formIsChanged, setFormIsChanged] = useState(false);
  const [isLoadingContents, setIsLoadingContents] = useState<boolean>(false);
  const [BankData, setBankData] = useState<any>(undefined);
  const [logoLoading, setLogoLoading] = useState<any>(false);
  const [errorInpStyle, setErrorInpStyle] = useState(
    "focus:outline-none focus:border-primary-700"
  );
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState<any>(undefined);

  // const inquiryOnclick = () => {
  //   const digitRegex = /\d/g;
  //   const matches = valueInput.match(digitRegex);
  //   if (matches?.length === 16) {
  //     setErrorFlag(false);
  //     // setStyleInfoAccount("visible");
  //     setDisableContinueBtn(false);
  //     setErrorInpStyle("focus:outline-none focus:border-primary-700");
  //   } else {
  //     setErrorFlag(true);
  //     setErrorMsg("شماره کارت معتبر نیست.");
  //     setErrorInpStyle("border-red-500 focus:border-red-500");
  //   }
  // };

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await axiosPrivate.get(BANKS_LIST);
        setBanks(response?.data?.data?.result);
      } catch (error) {
        console.error("Failed to fetch banks", error);
      }
    };

    fetchBanks();
  }, []);

  const access_token = localStorage.getItem("access_token");
  const store_uid = localStorage.getItem("selected_store_uid");
  const [base64Image, setBase64Image] = useState<any>(undefined);
  const [bankLogoFile, setbankLogoFile] = useState<any>(undefined);

  const [inputVal, setInputVal] = useState("");

  const handleCardNumberChange = (e: any, field: any) => {
    const newInputVal = e.target.value.replace(/ - /g, "");
    setInputVal(newInputVal); // This will trigger the useEffect below
    field.onChange(e);
  };

  useEffect(() => {
    if (inputVal?.length == 6 || inputVal?.length == 16) {
      setLogoLoading(true);
      const prefix = inputVal.slice(0, 6);
      const matchedBank: any = banks?.find((bank: any) =>
        bank?.pre_account_number?.includes(prefix)
      );
      if (matchedBank) {
        setSelectedBank(matchedBank);
        setValue("bank_uid", matchedBank.bank_uid, { shouldValidate: true }); // Assuming you want to set bank_uid here
        const fetchBanks = async () => {
          setLogoLoading(true);
          try {
            const response = await axiosPrivate.get(
              GET_FILE_UID(matchedBank?.logo)
            );
            setbankLogoFile(response?.data?.data);
            setLogoLoading(false);
          } catch (error) {
            console.error("Failed to fetch banks", error);
            setLogoLoading(false);
          }
        };
        fetchBanks();
      } else {
        setBase64Image(undefined);
        setbankLogoFile(undefined);
        // setSelectedBank(undefined);
        setLogoLoading(false);
        setValue("bank_uid", "", { shouldValidate: true }); // Clear and validate the field
      }
    } else if (inputVal?.length < 6) {
      setSelectedBank(undefined);
      setBase64Image(null); // Assuming setBase64Image should be called here
    }
  }, [inputVal]); // This will re-run the effect every time `inputVal` changes

  function cartBankConverter(st: string) {
    var dataLsit = st.split(" - ");
    var output = "";
    for (let i = 0; i < dataLsit?.length; i++) {
      output = output + dataLsit[i];
    }
    return output;
  }

  const formatBankCardNumber = (number: any) =>
    number ? number?.replace(/(\d{4})(?=\d)/g, "$1 - ") : "";

  const onSubmitStep4: SubmitHandler<IFormData> = async (data: IFormData) => {
    setIsSubmiting(true);
    const formattedData = {
      ...data,
      bank_uid: selectedBank?.bank_uid, // Include the bank_uid in your payload
      store_uid: store_uid ? store_uid : storeUid.store_uid,
      bank_card_number: cartBankConverter(data?.bank_card_number)
        ? data?.bank_card_number?.split(" - ").join("")
        : undefined,
      IBAN: "IR" + data?.IBAN,
      // bank_name: selectedBank?.bank_uid,
    };

    try {
      const endpoint = BankData
        ? STORE_STORE_BANK_INFO_UPDATE(
            store_uid ? store_uid : storeUid.store_uid
          )
        : STORE_STORE_BANK_INFO_CREATE;
      const method = BankData ? "put" : "post";

      const response = await axiosPrivate[method](endpoint, formattedData, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });

      if (response?.status >= 200 && response?.status < 300) {
        setStoreStateConfirmInfo(response?.data?.data?.store_state);
        setFormNo(formNo + 1);
        setIsSubmiting(false);
      } else {
        console.error(
          "Error in bank_info operation:",
          response?.data || response.statusText
        );
      }
    } catch (error) {
      setIsSubmiting(false);
      console.error("An unexpected error occurred:", error);
    }
  };

  const handleKeyPress = (e: any) => {
    // اجازه دادن تنها به ورودی عدد
    if (!/^\d$/.test(e.key) && e.key !== "Enter" && e.keyCode !== 13) {
      e.preventDefault();
    }
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  const getDataBank = () =>
    axiosPrivate
      .get(STORE_STORE_BANK_INFO_GET(store_uid), {
        headers: {
          // prettier-ignore
          "accept": "application/json",
          // prettier-ignore
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      })
      .then((res) => res?.data?.data);

  const BankDataQuery = useQuery({
    queryKey: ["BankData"],
    queryFn: () => getDataBank(),
  });

  useEffect(() => {
    if (BankDataQuery?.data) {
      setBankData(BankDataQuery.data); // Assume this sets the fetched data into the state
      // if (BankDataQuery?.data.bank) {
      //   setBase64Image(BankDataQuery?.data?.bank?.logo); // Assuming logo is the image data you need
      // }
      if (BankDataQuery.data.bank_uid) {
        // setSelectedBank(BankDataQuery.data); // Set the whole bank object or just the name, depending on need
        setValue("bank_uid", BankDataQuery.data.bank_uid, {
          shouldValidate: true,
        });
      }
    }
    if (selectedBank) {
      setBase64Image(selectedBank?.logo);
    }
  }, [
    BankDataQuery,
    setBankData,
    inputVal,
    setBase64Image,
    selectedBank,
    setValue,
  ]);

  useEffect(() => {
    if (BankData !== undefined) {
      setValue(
        "bank_card_number",
        formatBankCardNumber(BankData.bank_card_number)
      );
      setInputVal(BankDataQuery.data?.bank_card_number);
      setValue("account_number", BankData.account_number);
      setValue("IBAN", BankData?.IBAN?.replace(/\D/g, ""));
      setValue("bank_uid", selectedBank?.bank_name);
      setValue("branch_code", BankData?.branch_code);
      // setBankUID(BankData?.bank_uid);
    }
  }, [BankData]);

  useEffect(() => {
    if (getData === undefined && BankData !== undefined) {
      setGetData(watch());
    } else if (getData !== undefined) {
      setFormIsChanged(!_.isEqual(getData, watch()));
    }
  }, [watch(), BankData]);

  // useEffect(() => {
  //   const fetchBanks = async () => {
  //     setLogoLoading(true)
  //     try {
  //       const response = await axiosPrivate.get(GET_FILE_UID(base64Image));
  //       setbankLogoFile(response?.data?.data);
  //       setLogoLoading(false)
  //     } catch (error) {
  //       console.error("Failed to fetch banks", error);
  //       setLogoLoading(false)
  //     }
  //   };

  //   selectedBank?.logo && fetchBanks();
  // }, [selectedBank?.logo]);

  return (
    <>
      {isLoadingContents ? (
        <>
          <div className="flex gap-8 basis-3/4 rounded-md md:ml-8 ml-2 shadow-md">
            <div className=" full-screen">
              <Lottie options={defaultOptions} height={100} width={100} />
            </div>
          </div>
        </>
      ) : (
        <motion.form
          variants={childVariants}
          initial="initial"
          animate="final"
          className="flex flex-col flex-1 gap-12 rounded-md shadow-md"
        >
          <div className="flex flex-col flex-1 gap-12 rounded-md shadow-md">
            {/* <div className="w-[270px] lg:w-[364px] mr-14 md:mr-[60px] lg:mr-[240px]"></div> */}
            <div>
              <div className="w-full justify-center items-center  flex flex-col gap-2 text-gray-900">
                <div className="max-sm:flex-col max-sm:max-w-[280px] flex  whitespace-nowrap gap-4 min-w-5 max-w-[400px] w-full justify-start">
                  <label className="w-[140px]">
                    شماره کارت:
                    <span className="text-red-500">*</span>
                  </label>

                  <Controller
                    control={control}
                    name="bank_card_number"
                    render={({ field }) => (
                      <div className="flex flex-col w-full">
                        <div className="relative justify-start items-center flex w-full">
                          <InputMask
                            {...field}
                            dir="ltr"
                            mask="____ - ____ - ____ - ____"
                            replacement={{ _: /\d/ }}
                            className={`w-full flex pr-4 py-2 pl-[60px] bg-gray-50 border rounded-lg focus:outline-none  ${errorInpStyle}`}
                            onChange={(e) => handleCardNumberChange(e, field)}
                          />
                          {base64Image && bankLogoFile && (
                            <>
                              {logoLoading ? (
                                <div className="absolute top-auto w-6 h-6 left-4 bg-gray-50">
                                  <Lottie
                                    options={defaultOptions}
                                    height={20}
                                    width={20}
                                  />
                                </div>
                              ) : (
                                <>
                                  <img
                                    src={`${bankLogoFile?.url}`}
                                    alt="description"
                                    className="absolute top-auto w-6 h-6 left-4 "
                                  />
                                </>
                              )}
                            </>
                          )}
                        </div>
                        {errorFlag ? (
                          <p className="text-Body-OneLine/14/Regular text-red-600 mt-[10px]">
                            {errorMsg}
                          </p>
                        ) : (
                          <span className="invisible   text-Body-OneLine/14/Regular">
                            invisible
                          </span>
                        )}
                      </div>
                    )}
                  />
                </div>
                <div className="max-sm:flex-col max-sm:max-w-[280px] flex min-w-56 max-w-[400px] whitespace-nowrap gap-4 w-full justify-start">
                  <label className="w-[140px]">
                    شماره حساب:<span className="text-red-500">*</span>
                  </label>
                  <Controller
                    control={control}
                    name="account_number"
                    render={({ field }) => (
                      <div className="flex flex-col gap-1 justify-start items-start w-full">
                        <input
                          type="tel"
                          {...register("account_number", {
                            pattern: {
                              value: /^\d*$/,
                              message: "لطفاً تنها عدد وارد کنید.",
                            },
                          })}
                          dir="ltr"
                          className={`w-full p-2 pl-4 bg-gray-50 border rounded-lg focus:outline-none ${
                            errors.account_number
                              ? "text-red-600 border-red-500 bg-red-100 focus:text-red-700"
                              : "focus:border-primary-700"
                          }`}
                          maxLength={18}
                          onKeyPress={(e) => handleKeyPress(e)}
                        />
                        {errors["account_number"] ? (
                          <p className="text-Body-OneLine/14/Regular text-red-600">
                            {errors["account_number"].message}
                          </p>
                        ) : (
                          <span className="invisible   text-Body-OneLine/14/Regular">
                            invisible
                          </span>
                        )}
                      </div>
                    )}
                  />
                </div>

                <div className="max-sm:flex-col max-sm:max-w-[280px] flex gap-4 w-full min-w-56 max-w-[400px] whitespace-nowrap justify-start">
                  <label className="w-[140px]">
                    شماره شبا:<span className="text-red-500">*</span>
                  </label>
                  <Controller
                    control={control}
                    name="IBAN"
                    render={({ field }) => (
                      <div className="flex w-full gap-1 flex-col justify-center items-start">
                        <div className="relative flex w-full justify-center items-center">
                          <p
                            className={`absolute left-4 top-auto  ${
                              errors.IBAN ? `text-red-600` : `text-gray-500`
                            } text-sm`}
                          >
                            -IR
                          </p>
                          <input
                            type="tel"
                            onKeyPress={(e) => handleKeyPress(e)}
                            {...register("IBAN")}
                            dir="ltr"
                            // placeholder="IR-"
                            // prefix="IR-"
                            className={` bg-gray-50 flex pl-9 p-2 w-full justify-center items-center border rounded-lg focus:outline-none ${
                              errors.IBAN
                                ? "text-red-600 border-red-500 bg-red-100 focus:text-red-700"
                                : "focus:border-primary-700"
                            }`}
                            maxLength={24}
                          ></input>
                        </div>
                        {errors["IBAN"] ? (
                          <p className="text-Body-OneLine/14/Regular text-red-600">
                            {errors["IBAN"].message}
                          </p>
                        ) : (
                          <p className="invisible text-Body-OneLine/14/Regular">
                            invisible
                          </p>
                        )}
                      </div>
                    )}
                  />
                </div>
                <div className="max-sm:flex-col max-sm:max-w-[280px] flex w-full min-w-56 max-w-[400px] gap-4 whitespace-nowrap">
                  <label className="w-[140px]">نام بانک:</label>
                  <Controller
                    control={control}
                    name="bank_uid"
                    render={({ field }) => (
                      <div className="flex-col w-full flex items-center gap-1 justify-center">
                        <input
                          value={
                            selectedBank !== undefined
                              ? selectedBank?.bank_name
                              : ""
                          }
                          readOnly
                          disabled
                          {...register("bank_uid")}
                          onChange={(e) => {}} // Add a no-op onChange if using React Hook Form to avoid warnings
                          className={` border p-2 w-full flex text-center focus:outline-none rounded-lg bg-gray-50  ${
                            errors.bank_uid
                              ? "text-red-600 border-red-500 bg-red-100 focus:text-red-700"
                              : "focus:border-primary-700"
                          }`}
                        ></input>
                        {errors["bank_uid"] ? (
                          <p className="text-Body-OneLine/14/Regular text-red-600">
                            {errors["bank_uid"].message}
                          </p>
                        ) : (
                          <span className="invisible   text-Body-OneLine/14/Regular">
                            invisible
                          </span>
                        )}
                      </div>
                    )}
                  />
                </div>
                <div className="max-sm:flex-col max-sm:max-w-[280px] flex w-full min-w-56 max-w-[400px] gap-4 justify-start items-start whitespace-nowrap">
                  <label className="w-[140px]">
                    شعبه بانک:<span className="text-red-500">*</span>
                  </label>
                  <Controller
                    control={control}
                    name="branch_code"
                    render={({ field }) => (
                      <div className="flex flex-col gap-1 w-full">
                        <input
                          {...register("branch_code")}
                          className={` bg-gray-50 p-2 pr-4 border flex w-full rounded-lg focus:outline-none ${
                            errors.branch_code
                              ? "text-red-600 border-red-500 bg-red-100 focus:text-red-700"
                              : "focus:border-primary-700"
                          }`}
                        ></input>
                        {errors["branch_code"] ? (
                          <p className="text-Body-OneLine/14/Regular text-red-600">
                            {errors["branch_code"].message}
                          </p>
                        ) : (
                          <span className="invisible  text-Body-OneLine/14/Regular">
                            invisible
                          </span>
                        )}
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex w-full justify-center gap-1 pb-4 sticky bottom-0 bg-white right-0 left-0">
            <ButtonComponent
              variant="outlined"
              className="m-[8px] h-[40px] w-[120px]"
              onClick={() => setFormNo(formNo - 1)}
            >
              بازگشت
            </ButtonComponent>
            <ButtonComponent
              isClicked={isSubmiting}
              disabled={isSubmiting}
              type="submit"
              variant="filled"
              className="m-[8px] h-[40px] w-[120px]"
              onClick={handleSubmit(onSubmitStep4)}
            >
              ادامه
            </ButtonComponent>
          </div>
        </motion.form>
      )}
    </>
  );
}
export default BankAccount;
